import React from "react"
import { Box, Divider, Tooltip, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { dsColorNew } from "@palette"


function LegendChip({ icon, short, label, color, plain }) {
	return <Tooltip title={label} arrow>
		<Box sx={{
			display: 'inline-flex', alignItems: 'center', gap: 0.5,
			...(plain
				? { py: 0.25 }
				: { px: 0.75, py: 0.5, borderRadius: '6px', backgroundColor: dsColorNew.pillTrackBg }),
		}}>
			<IconSeeker icon={icon} iconWeight="light" sx={{ fontSize: 12, color: color || dsColorNew.textDark }}/>
			<Typography sx={{ fontSize: 12, fontWeight: plain ? 400 : 500, color: plain ? dsColorNew.textMuted : dsColorNew.textDark, lineHeight: 1.2, whiteSpace: 'nowrap' }}>
				{short || label}
			</Typography>
		</Box>
	</Tooltip>
}

// A group never splits: if the strip does not fit, the next group moves to the next line as a whole
const LegendGroup = ({ items, plain }) => <Box sx={{ display: 'flex', gap: plain ? 1.25 : 0.5, flexWrap: 'nowrap' }}>
	{items.map(item => <LegendChip key={item.label} plain={plain} {...item}/>)}
</Box>

// Legend of the icons a table shows: { icon, label, short?, color? } per item, in groups.
// "chips" draws each item in a small box; "plain" is icon + text, with a thin rule between groups.
export default function AppLegendChips({ groups = [], variant = 'chips', sx = {}, ...props }) {
	const plain = variant === 'plain'
	const shown = groups.filter(items => items.length)

	return <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', columnGap: 1.5, rowGap: 0.75, ...sx }} {...props}>
		{shown.map((items, idx) => <React.Fragment key={items[0].label}>
			{plain && !!idx && <Divider orientation="vertical" flexItem sx={{ my: 0.25, borderColor: dsColorNew.grayBorder }}/>}
			<LegendGroup items={items} plain={plain}/>
		</React.Fragment>)}
	</Box>
}
